import { db } from "@db";
import { updateSettings } from "@db/settings";
import { createFileRoute } from "@tanstack/react-router";
import { Checkbox } from "@ui/checkbox";
import {
  Field,
  FieldContent,
  FieldDescription,
  FieldGroup,
  FieldLabel,
  FieldLegend,
  FieldSet,
} from "@ui/field";
import { useLiveQuery } from "dexie-react-hooks";

export const Route = createFileRoute("/settings/general")({
  component: GeneralSettingsComponent,
});

function GeneralSettingsComponent() {
  const settings = useLiveQuery(() => db.settings.get("settings"));

  if (!settings) {
    return null;
  }

  const promptToRename = settings.promptToRenameNewFiles ?? true;

  return (
    <div className="max-w-xl p-6">
      <FieldSet>
        <FieldLegend>Files</FieldLegend>
        <FieldGroup>
          <Field orientation="horizontal">
            <Checkbox
              id="promptToRenameNewFiles"
              checked={promptToRename}
              onCheckedChange={(checked) =>
                updateSettings({ promptToRenameNewFiles: checked === true })
              }
            />
            <FieldLabel htmlFor="promptToRenameNewFiles">
              <FieldContent>
                Prompt to rename new files
                <FieldDescription>
                  Automatically open the rename dialog after creating a new
                  alignment or collection.
                </FieldDescription>
              </FieldContent>
            </FieldLabel>
          </Field>
        </FieldGroup>
      </FieldSet>
    </div>
  );
}
